import { useState } from "react";
import { Search, Loader2 } from "lucide-react";
import { api } from "@/App";

// flashtec.ch's own search page has no URL-based prefill (its input always
// renders empty server-side regardless of query params), so there's no way
// to "hand off" a hardware number to their form — instead this calls their
// actual lookup endpoint via our own backend proxy (GET /api/bosch-lookup)
// and shows the result inline, without ever leaving the page.
export default function BoschLookup({ hardware }) {
  const [state, setState] = useState("idle"); // idle | loading | done | error
  const [result, setResult] = useState(null);

  if (!hardware) return null;

  const lookup = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    setState("loading");
    try {
      const { data } = await api.get("/bosch-lookup", { params: { hw: hardware } });
      setResult(data.result);
      setState("done");
    } catch (err) {
      setState("error");
    }
  };

  return (
    <span className="inline-flex items-center gap-1.5">
      {state === "idle" && (
        <button
          type="button"
          onClick={lookup}
          data-testid="bosch-lookup-btn"
          title="Bosch-Chip-Familie bei flashtec.ch nachschlagen"
          className="inline-flex items-center justify-center w-5 h-5 rounded border border-neutral-700 text-neutral-400 hover:text-[#E13636] hover:border-[#E13636]/60 transition shrink-0"
        >
          <Search className="w-3 h-3" />
        </button>
      )}
      {state === "loading" && (
        <Loader2 className="w-3.5 h-3.5 text-neutral-500 animate-spin shrink-0" />
      )}
      {state === "done" && (
        <span
          data-testid="bosch-lookup-result"
          className={`text-[10px] font-mono rounded px-1.5 py-0.5 border ${
            result
              ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-300"
              : "border-neutral-700 bg-panel text-neutral-500"
          }`}
        >
          {result || "kein Treffer"}
        </span>
      )}
      {state === "error" && (
        <span className="text-[10px] text-rose-400">Fehler</span>
      )}
    </span>
  );
}
